import React from "react";
import Search from "../../search/search";
import { NavBarBrand } from "./nav-bar-brand";
import { NavBarButtons } from "./nav-bar-buttons";
import { NavBarTabs } from "./nav-bar-tabs";
import { useAuth0 } from "@auth0/auth0-react";

export const NavBar = () => {
  const { isAuthenticated, getAccessTokenSilently, user } = useAuth0();
  return (
    <div className="nav-bar__container">
      <nav className="nav-bar">
        <NavBarBrand />
        {isAuthenticated && (
          <>
            <Search />
          </>
        )}
        <NavBarTabs />
        <NavBarButtons />
      </nav>
    </div>
  );
};
